import { environment } from '@app/environments/environment';
import { EsResponseModel, ListingBreadcrumbsDocumentModel } from '@app/models/elastic-search';
import { EsServiceBase } from '@app/services/abstracts/es-service.base';

export class EsListingBreadcrumbsService extends EsServiceBase {
    readonly #breadcrumbsIndexName = 'noc-listing-breadcrumbs';
    readonly #breadcrumbsIndexVersion = environment.LISTING_BREADCRUMBS_ES_VERSION;

    private static _instance: EsListingBreadcrumbsService;

    protected get indexName(): string {
        return this.#breadcrumbsIndexVersion
            ? `${this.#breadcrumbsIndexName}-${this.#breadcrumbsIndexVersion}`
            : this.#breadcrumbsIndexName;
    }

    public static get instance(): EsListingBreadcrumbsService {
        if (!this._instance) {
            this._instance = new EsListingBreadcrumbsService();
        }
        return this._instance;
    }

    /**
     * Load a breadcrumbs document by ID, e.g.
     *   GET /noc-listing-breadcrumbs-1/_doc/poi_NOC_154907
     */
    public async loadById(docId: string): Promise<ListingBreadcrumbsDocumentModel | null> {
        try {
            const response: EsResponseModel<ListingBreadcrumbsDocumentModel> =
                await this.get<ListingBreadcrumbsDocumentModel>(this.indexName, docId);

            return response?._source ?? null;
        } catch {
            return null;
        }
    }
}
